const formatter = new Intl.NumberFormat("ru-RU", { style: "currency", currency: "USD", maximumFractionDigits: 6 });
export const usd = (value: number | null | undefined) => value == null ? "Уточняется" : formatter.format(value);
